export const nbsp = '\u00A0';
export const breakline = '\u000A';
